const FidelioOptionType = {
  ROOM: 'room',
  CARD: 'card'
};

export default FidelioOptionType;
